import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import { isValidPhoneNumber } from "@/utils/phoneNumber"

import { moreThanMessage, requiredMessage } from "../errorMessage"

export type CancelForm = yup.Asserts<typeof cancelScheme>

const normalizeNumberInput = (value: number | undefined): number | undefined =>
	Number.isNaN(value) ? undefined : value

export const cancelScheme = yup.object({
	visitCounts: yup
		.number()
		.transform(normalizeNumberInput)
		.min(0, moreThanMessage(0)),
	originPrice: yup
		.number()
		.transform(normalizeNumberInput)
		.required(moreThanMessage(0))
		.min(0, moreThanMessage(0)),
	name: yup.string().required(requiredMessage("請求先")),
	// staff_name: yup.string(),
	phoneNumber: yup
		.string()
		.required(requiredMessage("電話番号"))
		.test(
			"isValidJapanDomesticPhoneNumber",
			"0から始まる正しい電話番号を入力してください。",
			(value) => {
				if (!value) return true
				return isValidPhoneNumber(value)
			}
		),
})

export const cancelResolver = yupResolver(cancelScheme)
